import Vue from 'vue'
import grid from './grid/index.vue'
import edit from './edit/index.vue'
import select from './select.vue'

Vue.component('app-marca-grid', grid)
Vue.component('app-marca-edit', edit)
Vue.component('app-marca-select', select)
